
import { mapGetters,mapActions } from 'vuex'
export default {
  name: 'BlocksArticleSidebar',
  props: {
    // CSS selector for the article content container
    contentSelector: {
      type: String,
      default: 'article',
    },
    // Which heading levels to include
    headingLevels: {
      type: Array,
      default: () => ['h2'],
    },
    modal: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: 'Download our free guide',
    },
  },
  data() {
    return {
      activeSection: null,
      ctaHovered: false,
      navLinks: [],
    }
  },
  computed: {
    ...mapGetters({
      activeModal : 'pages/getActiveModal',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.buildNavLinks()
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
    }),
    updateModal(id){
      const newId = this.$nuxt.$options.filters.convertModal(id)
      this.updateActiveModal(newId)
      console.log('Active Modal: ',this.activeModal)
    },
    // Build nav links from headings found in the content container
    buildNavLinks() {
      const container = document.querySelector(this.contentSelector)
      if (!container) {
        console.warn(`ArticleSidebar: no element found for selector "${this.contentSelector}"`)
        return
      }

      const headings = Array.from(container.querySelectorAll(this.headingLevels.join(', ')))

      console.log('container:', container)
      console.log('headings found:', headings)
      console.log('headings with ids:', headings.filter(el => el.id))
  

      // Only include headings that already have an id — avoids auto-slug complexity
      this.navLinks = headings
        .filter(el => el.id)
        .map(el => ({
          id: el.id,
          label: el.textContent.trim(),
        }))
    },
    // Highlight the nav link whose section is currently in view
    onScroll() {
      const offsets = this.navLinks
        .map(l => {
          const el = document.querySelector(`#${l.id}`)
          if (!el) return null
          const top = el.getBoundingClientRect().top + window.scrollY - 100
          return { id: l.id, top }
        })
        .filter(Boolean)
      const current = offsets.filter(s => window.scrollY >= s.top).pop()
      this.activeSection = current?.id || null
    },
    scrollTo(id) {
      const el = document.querySelector(`#${id}`)
      if (!el) return
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 18, behavior: 'smooth' })
    },
  },
}
